<app-breadcrumb *ngIf="showFilter"  [master]="'Należności'" [parentName]="'Wpłaty'" [name]="'Lista'"></app-breadcrumb>
<div class="receivables-payment-import-row-list-container">
  <form *ngIf="showFilter"  (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="receivables-payment-import-row-list-filters">

    <mat-form-field class="receivables-payment-import-row-list-filter">
      <mat-label>Tytuł przelewu</mat-label>
      <input matInput placeholder="Tytuł przelewu" name="contains$transferTitle" [(ngModel)]="initialFilters.contains$transferTitle">
    </mat-form-field>

    <mat-form-field class="receivables-payment-import-row-list-filter">
      <mat-label>{{ownerName}}</mat-label>
      <input matInput placeholder="{{ownerName}}" name="contains$ownerName" [(ngModel)]="initialFilters.contains$ownerName">
    </mat-form-field>

    <app-datepicker
      class="receivables-payment-import-row-list-filter"
      label="Data księgowania od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$postingDate" name="gte$postingDate"
    ></app-datepicker>

    <app-datepicker
      class="receivables-payment-import-row-list-filter"
      label="Data księgowania do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$postingDate" name="lte$postingDate"
    ></app-datepicker>

    <mat-form-field class="receivables-payment-import-row-list-filter">
      <mat-label>Numer Salda</mat-label>
      <input matInput placeholder="Numer Salda" name="balanceTitle" [(ngModel)]="initialFilters.balanceTitle">
    </mat-form-field>

    <mat-form-field class="receivables-payment-import-row-list-filter">
      <mat-label>Kwota przelewu</mat-label>
      <input matInput placeholder=">Kwota przelewu" name="transferAmount" [(ngModel)]="initialFilters.transferAmount">
    </mat-form-field>

    <app-dict
      [multiple]="true" label="Status wpłaty"
      class="receivables-payment-import-row-list-filter"
      dictType="receivables_payment_status"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <mat-form-field class="receivables-payment-import-row-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="policyNumber" [(ngModel)]="initialFilters.policyNumber">
    </mat-form-field>

    <mat-form-field appearance="standard" class="receivables-payment-import-row-list-filter">
      <mat-label>Wpłata ręczna</mat-label>
      <mat-select [(ngModel)]="initialFilters.manualPayment" name="manualPayment">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div *ngIf="showFilter"  class="receivables-payment-import-row-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()">Pobierz raport</button>
    <button (click)="filter()"  mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()"  mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <div *ngIf="!showFilter"  class="receivables-payment-import-row-list-buttons">
    <button *ngIf="(userPermissions | async).receivables.read_report" [disabled]="!(userPermissions | async).receivables.read_report" mat-raised-button class="report-button" (click)="downloadReport()">Pobierz raport</button>
  </div>

  <table mat-table [dataSource]="rows" matSort (matSortChange)="sortChanged($event)">



    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef > Tytuł przelewu </th>
      <td mat-cell *matCellDef="let element">
        <div class="statusChange-flex-container">
          <mat-chip-list *ngIf="!element.import && !element.transfer" >
            <mat-chip class="statusChange-button-container" color="primary"  matTooltip="Wpłata dodana ręcznie ">R</mat-chip>
          </mat-chip-list>
          <mat-chip-list *ngIf="!element.import && element.transfer" >
            <mat-chip class="statusChange-button-container" color="accent"  matTooltip="Przeksięgowanie ">P</mat-chip>
          </mat-chip-list>
          <a class="default-link" [routerLink]="['/naleznosci/wplaty/szczegoly', element?.uuid]">
            {{element.transferTitle}}
          </a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.receivablesBalance?.partner !== null" class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', element.receivablesBalance?.uuid]">
          <mat-chip-list >
            <mat-chip class="statusChange-button-container"  selected  matTooltip="Partner">P</mat-chip> {{element.receivablesBalance?.partner?.shortName}}
          </mat-chip-list>
          <!--        {{element.partner?.shortName}}-->
        </a>
        <a *ngIf="element.receivablesBalance?.ofwca !== null " class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', element.receivablesBalance?.uuid]">
          <mat-chip-list >
            <mat-chip class="statusChange-button-container" color="warn" selected  matTooltip="OFWCA">O</mat-chip>           {{element.receivablesBalance?.ofwca?.firstName}} {{element.receivablesBalance?.ofwca?.lastName}}
          </mat-chip-list>
          <!--          {{element.ofwca?.firstName}} {{element.ofwca?.lastName}}-->
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner">
      <th mat-header-cell *matHeaderCellDef> {{ownerName}} </th>
      <td mat-cell *matCellDef="let element">
        {{element.ownerName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="statement">
      <th mat-header-cell *matHeaderCellDef > Numer salda</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/naleznosci/salda/szczegoly', element?.receivablesBalance?.uuid]">
          {{element?.receivablesBalance ? element?.receivablesBalance?.recordId : ''}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Kwota przelewu </th>
      <td mat-cell *matCellDef="let element">
        {{(element.transferAmount !== null ? element.transferAmount : 0) | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="postingData">
      <th mat-header-cell *matHeaderCellDef> Data księgowania  </th>
      <td mat-cell *matCellDef="let element">
        {{element.postingDate | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status wpłaty </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator  [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

